import { Content } from "@/components/Content";
import { createTitle } from "@/functions/createTitle";
import * as additionalComponents from "./__components";
import { Collection } from "@sourceflow-uk/sourceflow-sdk";
import { getTeam } from "@/getters/getTeam";

export default function Page({ content }) {
  return (
    <>
      <Content items={content} additionalComponents={additionalComponents} />
    </>
  );
}

export async function getStaticProps({ params: { url_slug } }) {
  const member = getTeam({ url_slug });

  return {
    props: {
      meta: {
        title: createTitle(member.name, "Meet The Team", "About Us"),
      },
      content: [
        { component: "MemberDetails", props: { className: "", ...member } },
        { component: "LinkCards", props: { className: "bg-grey-light" } },
        { component: "AskExpertsCTA", props: { className: "" } },
      ],
    },
  };
}

export async function getStaticPaths() {
  return {
    paths: (await Collection("team")).filter((i) => i.page.en).getPaths("url_slug"),
    fallback: false,
  };
}
